import { proxy } from 'valtio'

export const listNodeFullscreenStore = proxy<Record<string, true>>({})

export function openListNodeFullscreen(nodeId: string) {
  listNodeFullscreenStore[nodeId] = true
}

export function closeListNodeFullscreen(nodeId: string) {
  delete listNodeFullscreenStore[nodeId]
}
